import axios from "axios";

export const getQueryVariable = (variable, hash) => {
  let query = hash.split("?")[1];
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
};
export const checkVersion = () => {
  axios.get(`./version.json?v=${new Date().getTime()}`).then(function(res) {
    const headVersion = document.head.getAttribute("data-version");

    let noLocalhost = window.location.host.indexOf("192.168.") === -1;
    let userId = getQueryVariable("userId", location.hash);
    let mobile = getQueryVariable("mobile", location.hash);
    let source = getQueryVariable("source", location.hash);

    if (noLocalhost && headVersion != res.data.version) {
      window.location.href = `${location.origin}${
        location.pathname
      }?version=${new Date().getTime()}/#/lottery?userId=${userId}&mobile=${mobile}&source=${source}`;
    }
  });
};
